let URL;
let appMode = process.env.REACT_APP_ENV;
let ASSET_URL = "https://s3-noi.aces3.ai/veegram/";
let ASSET_URL_NEW = "s3.amazonaws.com/";

if (appMode === "development") {
  // URL = "http://localhost:3369/api/";
  // URL = "http://13.235.203.89:3369/api/";
  // ----------- Production ------------
  URL = "https://backend.crikclips.com/api/";
} else {
  // URL = "http://localhost:3369/api/";
  // ----------- Testing ----------
  // URL = "http://13.235.203.89:3369/api/";
  // -------- Production ---------------
  URL = "https://backend.crikclips.com/api/";
}

let apiPath = {
  baseURL: URL,
  assetURL: ASSET_URL,
  assetURLNew: ASSET_URL_NEW,
  dashboard: "admin/dashboard/get-dashboard",
  companyDashboard: "admin/dashboard/company-dashboard",
  revenueFilterDashboard: "admin/dashboard/revenue-graph",

  listOnDemandOrder: "admin/order/on-demand/list",
  viewOnDemandOrder: "admin/order/on-demand/view",
  listSubscriptionOrder: "admin/order/subscription/list",
  viewSubscriptionOrder: "admin/order/subscription/view",
  changeOrderStatus: "admin/order/change-status",

  // Auth API
  logout: "admin/auth/logout",
  login: "admin/auth/login",
  profile: "admin/auth/get-profile",
  updateProfile: "admin/auth/update-profile",
  changePassword: "admin/auth/change-password",
  updateAppSetting: "admin/auth/update-app-setting",

  forgotPassword: "admin/auth/forgot-password",
  verifyOTP: "admin/auth/verify-otp",
  resetPassword: "admin/auth/reset-password",

  // Users APIs
  listUsers: "admin/users",
  viewUser: "admin/users",
  deleteUser: "admin/users/delete",
  userFollowers: "admin/users/followers",
  userFollowing: "admin/users/following",
  changeUserStatus: "admin/users/change-status",
  filteredUsers: "admin/users/get-filtered-users",
  listLocations: "admin/users/get-locations",

  // Sessions APIs
  listSession: "admin/users/get-sessions",
  terminateSession: "admin/users/terminate-session",

  // Admins APIs
  listAdmins: "admin/sub-admins",
  viewAdmin: "admin/sub-admins",
  addSubAdmin: "admin/sub-admins",
  updateStatus: "admin/sub-admins",
  updateSubAdmin: "admin/sub-admins",
  listLogActivities: "admin/sub-admins/log-activity",

  // leader board api
  topLeaderBoard: "admin/leaderboard/top",
  topLeaderBoardBySkill: "admin/leaderboard/by-skill",

  // coach academy apis
  coachAcademyList: "admin/coachAcademy/list",
  verifyCoachAcademy: "admin/coachAcademy/verify",

  // Tournaments APIs
  tournamentsList: "admin/tournament",
  tournamentById: "admin/tournament/detail",
  tournamentLeaderboard: "admin/tournament/leaderboard",
  changeTournamentStatus: "admin/tournament/status",
  deleteTournament: "admin/tournament/delete",


  // Category APIs
  addCategory: "admin/category/create-category",
  listCategory: "admin/category/get-categories",
  updateCategory: "admin/category/update-category",
  updateCategoryStatus: "admin/category/change-status",
  deleteCategory: "admin/category/delete-category",

  // ClipType APIs
  addClipType: "admin/ClipType/create-ClipType",
  listClipType: "admin/ClipType/get-clip-types",
  updateClipType: "admin/ClipType/update-ClipType",
  updateClipTypeStatus: "admin/ClipType/change-status",
  deleteClipType: "admin/ClipType/delete-ClipType",

  // Skill Tag APIs
  addSkillTag: "admin/tag/create-tag",
  listSkillTags: "admin/tag/get-tags",
  updateSkillTag: "admin/tag/update-tag",
  updateTagStatus: "admin/tag/change-status",
  deleteTag: "admin/tag/delete-tag",
  listSkill: "admin/tag/get-tag",

  // Role APIs
  addRole: "admin/role/create-role",
  listRole: "admin/role/get-roles",
  updateRole: "admin/role/update-role",
  updateRoleStatus: "admin/role/change-status",
  deleteRole: "admin/role/delete-role",

  //Point Rule Manager
  addPointRule: "admin/point/create-point",
  updatePointRule: "admin/point/update-point",
  listPointsRule: "admin/point/get-point-rules",
  changePointStatus: "admin/point/update-status",

  // Posts Manager
  listPosts: "admin/posts",
  getPost: "admin/posts",
  deletePost: "admin/posts",
  changePostStatus: "admin/posts/toggle-post",
  reviewPost: "admin/posts/update-status",
  listReviewPosts: "admin/posts/reviews-post",
  getPostCategories: "admin/posts/get-categories",

  // Group Manager
  listGroups: "admin/group/get-groups",
  changeGroupAdmin: "admin/group/change-admin",
  changeGroupStatus: "admin/group/update-status",
  listGroup: "admin/group/get-group",
  deleteGroup: "admin/group/delete-group",
  listRegions: "admin/group/get-regions",

  // Reports Manager
  listReports: "admin/report/get-reports",
  getReport: "admin/report/get-report",
  deleteReport: "admin/report",
  sendTemplate: "admin/report/send-template",
  createViolation: "admin/violation/create-violation",
  listViolationList: "admin/violation/get-violation",

  // EmailTemplate APIs
  listEmailTemplate: "admin/template/get-templates",
  editEmailTemplate: "admin/template/edit-email-template",
  updateEmailStatus: "admin/template/update-status",

  // Notification Manger
  listAdminNotification: "admin/notification/get-admin-notifications",
  sendNowNotification: "admin/notification/send-now",
  addAdminNotification: "admin/notification/create-notification",
  scheduleNotification: "admin/notification/schedule-admin-notification",
  getNotification: "admin/notification/get-admin-notification",
  updateAdminNotification: "admin/notification/update-admin-notification",
  listMyNotification: "admin/notification/get-notification",
  readAllNotification: "admin/notification/read-all-notification",
  readNotification: "admin/notification/read-single-notification",
  deleteAllNotification: "admin/notification/delete-notifications",
  updateAdminNotificationStatus:
    "admin/notification/update-admin-notification-status",

  // Level Manager
  listLevels: "admin/level/get-levels",
  addLevel: "admin/level/create-level",
  updateLevel: "admin/level/update-level",
  changeLevelStatus: "admin/level/update-status",

  // Badge Manager
  listBadges: "admin/badge/get-badges",
  addBadge: "admin/badge/create-badge",
  updateBadge: "admin/badge/update-badge",
  changeBadgeStatus: "admin/badge/change-status",
  deleteBadge: "admin/badge/delete-badge",

  // Reward Manager
  listRewards: "admin/reward/get-rewards",
  addReward: "admin/reward/create-reward",
  updateReward: "admin/reward/update-reward",
  changeRewardStatus: "admin/reward/change-status",
  deleteReward: "admin/reward/delete-reward",
  updateRewardStatus: "admin/reward//change-status",

  // Redemption Manager
  listRedemption: "admin/redemption/get-redemptions",

  // Integration Manager
  listIntegrations: "admin/integration/get-integrations",
  addIntegration: "admin/integration/create-integration",
  updateIntegration: "admin/integration/update-integration",

  // Maintenance Manager
  listMaintenance: "admin/maintenance/get-maintenance",
  addMaintenanace: "admin/maintenance/create-maintenance",

  // Policy Manager
  publishPolicy: "admin/policy/create-policy",
  listPolicies: "app/policy/get-policy",
  adminListPolicies: "admin/policy/get-policies",
  updatePolicy: "admin/policy/update-policy",

  // Search
  listGlobalSearchData: "admin/global-search",

  // Content APIs
  listContent: "admin/content/list",
  addEditContent: "admin/content/add-edit",
  statusContent: "admin/content/status",
  viewContent: "admin/content/view",

  // Support API's
  addSupport: "app/support/create-support",

  // Common Routes
  allUserList: "common/users-list",
  prodcutList: "common/prodcut",
  categoryList: "common/category",
  subCategoryList: "common/sub-category",
  productList: "common/product",
  vendorProductList: "common/vendor/product",
  VendorBranch: "common/branch-list",
  // getAppSetting: "common/app-setting",
  activity: "common/user-activity",

  getAllUserList: "common/get-users-list", // This route is use for payment realisation manager.

  // Music APIs
  addMusic: "admin/music/add",
  getMusic: "admin/music/get",
  changeMusicStatus: "admin/music/status",
  updateMusic: "admin/music/edit",
  deleteMusic: "admin/music/delete",

};

export default apiPath;
